import { useEffect, useRef, useState } from 'react';
import Offcanvas from 'react-bootstrap/Offcanvas';
import BackButton from 'components/BackButton';
import Dialog from 'components/Dialog';
import withOrderService from 'hocs/withOrderService';
import withOutlet from 'hocs/withOutlet';
import withUser from 'hocs/withUser';
import withCartModeFunction from 'ui/CartMode/hocs/withCartMode';
import withQuitOrder from 'ui/QuitOrder/hocs/withQuitOrder';
import * as ComponentUtils from 'utils/component';
import * as ZIndexUtils from 'utils/zIndexUtils';

const Sidenav = ({
    setAllowNavigation,
    user,
    orderSessionData,
    openAboutDialog,
    closeSidenav,
    readCartMode,
    openQuitOrderDialog
}) => {
    const { shareCart } = orderSessionData;

    const sidenavRef = useRef();
    const [showTerms, setShowTerms] = useState(false);
    const [showPrivacy, setShowPrivacy] = useState(false);
    const [termsContent, setTermsContent] = useState('');
    const [privacyContent, setPrivacyContent] = useState('');

    useEffect(() => {
        if (showTerms && !termsContent) {
            fetch('/legal/TermsAndConditions.html')
                .then((res) => res.text())
                .then((html) => setTermsContent(html))
                .catch(() => setTermsContent('<p>Failed to load content.</p>'));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showTerms]);

    useEffect(() => {
        if (showPrivacy && !privacyContent) {
            fetch('/legal/PrivacyNotice.html')
                .then((res) => res.text())
                .then((html) => setPrivacyContent(html))
                .catch(() => setPrivacyContent('<p>Failed to load content.</p>'));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showPrivacy]);

    const sidenavItems = [
        {
            icon: 'fas fa-shopping-cart',
            text: 'Cart Mode',
            onClick: () => readCartMode()
        },
        {
            icon: 'fas fa-info',
            text: 'About',
            onClick: () => openAboutDialog()
        },
        {
            icon: 'fas fa-door-open',
            text: 'Quit Order',
            onClick: () => openQuitOrderDialog(setAllowNavigation)
        }
    ];

    function onSidenavOpened() {
        ZIndexUtils.updateZIndexWithClassName('.offcanvas-backdrop');
        ZIndexUtils.updateZIndexWithComponent(sidenavRef.current.dialog);
    }

    return (
        <>
            <Offcanvas show placement="start" onHide={closeSidenav} onShow={onSidenavOpened} ref={sidenavRef}>
                <Offcanvas.Header
                    className="align-items-start"
                    style={{ background: 'var(--primary)', height: '15vh' }}
                >
                    <span className="text-white fw-bold">
                        {`Welcome, Guest ${shareCart ? user.getCurrentUserItemSeq() : ''}`}
                    </span>

                    <BackButton className="d-none" onClick={closeSidenav} />
                </Offcanvas.Header>

                <Offcanvas.Body className="d-flex flex-column justify-content-between">
                    <div>
                        {sidenavItems.map((item) => (
                            <div key={item.text} className="d-flex align-items-center mb-4" onClick={item.onClick}>
                                <span className={`col-1 ${item.icon} text-primary text-center me-3`} />
                                <span>{item.text}</span>
                            </div>
                        ))}
                    </div>

                    <div className="text-center text-decoration-underline fs-6">
                        <span className="text-muted" role="button" onClick={() => setShowTerms(true)}>
                            Terms & Conditions
                        </span>
                        <span className="mx-2">|</span>
                        <span className="text-muted" role="button" onClick={() => setShowPrivacy(true)}>
                            Privacy Notice
                        </span>
                    </div>
                </Offcanvas.Body>
            </Offcanvas>

            <Dialog isOpen={showTerms} title="Terms & Conditions" fullScreen closeDialog={() => setShowTerms(false)}>
                <div className="p-3" dangerouslySetInnerHTML={{ __html: termsContent }} />
            </Dialog>

            <Dialog isOpen={showPrivacy} title="Privacy Notice" fullScreen closeDialog={() => setShowPrivacy(false)}>
                <div className="p-3" dangerouslySetInnerHTML={{ __html: privacyContent }} />
            </Dialog>
        </>
    );
};

const hocs = [withOrderService, withOutlet, withUser, withCartModeFunction, withQuitOrder];

export default ComponentUtils.compose(hocs)(Sidenav);
